import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const currentUser = useSelector((state) => state.auth.user);

  // Check local storage for token and expiration
  const token = localStorage.getItem('authToken');
  const expiration = localStorage.getItem('authExpiration');

  // Check if the user is authenticated
  const isAuthenticated = !!(currentUser || (token && expiration && Date.now() < expiration));

  // Check if the user has the required role
  const hasRequiredRole = allowedRoles ? allowedRoles.includes(currentUser?.role) : true;

  // Redirect if not authenticated or if role is not allowed
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (allowedRoles && !hasRequiredRole) {
    return <Navigate to="/" />;
  }

  return children; // Render children if authenticated and has the required role
};

export default ProtectedRoute;
